import ListingsPaneUI from 'browse/ui/listings-pane';
import ListingsPaneData from 'browse/data/listings-pane';
import NdaData from 'browse/data/nda';
import ArchiveData from 'browse/data/archive';
import ClientsData from 'browse/data/clients';
import ListingToolbarUI from 'browse/ui/listings-toolbar';
import HeaderUI from 'browse/ui/header';
import NdaModalUI from 'browse/ui/nda-modal';

document.addEventListener('DOMContentLoaded', () => {
    ListingsPaneData.attachTo(document);
    ArchiveData.attachTo(document);
    NdaData.attachTo(document);
    ClientsData.attachTo(document);

    ListingsPaneUI.attachTo('[data-listings-pane]');
    ListingToolbarUI.attachTo('[data-listings-toolbar]');
    HeaderUI.attachTo('[data-browse-header]', {
        categoryHeadingMap: window.browseHeaderCategoryMap,
    });
    NdaModalUI.attachTo('[data-nda-modal]');
});



// WEBPACK FOOTER //
// ./src/web/js/browse/layout.js